module.exports = __webpack_public_path__ + "static/assets/c73619fea5bb43c53a080399a35273be.png";